import { NDfModal } from '@df/ui/modal/df-modal.interface';
import { DfModalService } from '@df/ui/modal/df-modal.service';

/**
 * Rewgisters CMS component as modal
 */
export function DfModal(config: Omit<NDfModal.IBaseModalConfig, 'component' | 'type'>) {
    return (component): any => {
        DfModalService.register({ component, ...config, type: 'modal' });
        return component;
    };
}
